export const getRepaymentAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_REPAYMENT_DETAILS":
      return action.data;

    default:
      return state;
  }
};
